import { category as BudgetCategory } from '@/__generated__/requests'

import { capitalizeFirstLetter } from '@/helpers/capitalizeFirstLetter.helper'

export function mapCategories(category: BudgetCategory) {
  switch (category) {
    case BudgetCategory.ENTERTAINMENT:
      return 'Entertainment & Lifestyle'
    case BudgetCategory.FOOD:
      return 'Food & Dining'
    case BudgetCategory.MEDICAL:
      return 'Medical'
    case BudgetCategory.HOUSING:
      return 'Housing & Utilities'
    case BudgetCategory.TRANSPORTATION:
      return 'Transportation & Travel'
    case BudgetCategory.FINANCIAL:
      return 'Financial Obligations'
    case BudgetCategory.GIVING:
      return 'Giving & Community'
    case BudgetCategory.OTHER:
      return 'Other / Uncategorized'
    default:
      return capitalizeFirstLetter(category)
  }
}
